export default __webpack_public_path__ + "static/media/otpkey.916e4c0d.svg";